// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".internal-nav[data-v-4a41f204] {\n  display: flex;\n  border-bottom: solid 1px #ececec;\n  padding-left: 28px;\n}\n.internal-nav a[data-v-4a41f204] {\n  padding: 27px 18px;\n  font-size: 16px;\n  color: #2c333a;\n  transition: color 0.2s ease;\n}\n.internal-nav a[data-v-4a41f204]:hover {\n  color: #009bff;\n}\n.internal-nav a.router-link-active[data-v-4a41f204] {\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
